import styled from "styled-components";
import { params, colors } from "../../../theme/Params";

export const ScMarkupPanel = styled.div`
  background-color: white;
  width: 372px;
  flex-grow: 0;
  flex-shrink: 0;
  height: calc(100vh - 140px);
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: ${params.boxShadow};
  margin-top: 16px;
  border-radius: ${params.containerBlockRadius};

  .block {
    padding: 16px 24px 8px 24px;

    & button {
      background: none;
      border: none;
      width: 100%;
      text-align: left;
      display: flex;
      padding: 10px;
      margin-top: 5px;
      border-radius: 4px;

      .icon-container {
        margin-right: 10px;
      }

      :hover,
      &.active {
        background: #e8f4ff;
        border-radius: ${params.containerBlockRadius};
      }
    }

    .header {
      font-weight: 600;
      font-size: 16px;
      line-height: 23px;
    }

    hr {
      margin-left: -30px;
      width: calc(100% + 60px);
      background: ${colors.grey20};
      height: 1px;
      border: none;
      margin-top: 10px;
      margin-bottom: 14px;
    }

    .objects-container {
      display: flex;
      gap: 15px;
      flex-wrap: wrap;
      margin-top: 30px;
    }
  }

  .footer {
    width: 100%;
    padding: 30px 30px 52px;
    position: absolute;
    bottom: 0;

    & > button {
      width: 100%;
      margin-top: 16px;
    }
  }
  .modal-save {
    //width: 403px;
    //height: 301px;
    //text-align: center;
    //.buttons {
    //  justify-content: center;
    //}
  }
`;
